import React from "react";
import { useLocation, Link } from "react-router-dom";
import Stepper from "containers/Contracts/components/Stepper";
import { FaCheckCircle } from "react-icons/fa";
import { Card, CardBody, Container } from "reactstrap";
import {
	RowContainer,
	Title,
	MessageContainer,
	MessageTitle,
	MessageText,
	IconContainer,
	ButtonsContainer,
	Button
} from "./styles";

const ContractSolicitationCompleted = () => {
	const { state } = useLocation();
	const contractId = state?.contractId;

	return (
		<Container className="dashboard">
			<Card>
				<CardBody>
					<Stepper currentStep={3} />

					<RowContainer>
						<Title>Solicitação de Contratos</Title>
					</RowContainer>
					<MessageContainer>
						<IconContainer>
							<FaCheckCircle size={64} color="#00BC7D" />
						</IconContainer>
						<MessageTitle>
							{contractId
								? "Solicitação concluída"
								: "Solicitação de contratos em massa concluída"}
						</MessageTitle>
						<MessageText>
							{contractId
								? "Sua solicitação foi cadastrada com sucesso. Você pode acompanhar o andamento na área de solicitações."
								: "Sua solicitação em massa foi processada e cadastrada com sucesso. Você pode acompanhar o andamento na área de solicitações."}
						</MessageText>
					</MessageContainer>
					<ButtonsContainer>
						<Link to="/contracts/contract-solicitation">
							<Button primary={!contractId}>Ver todas as solicitações</Button>
						</Link>
						{contractId && (
							<Link to={`/contracts/contract-solicitation/${contractId}`}>
								<Button primary>Acompanhar solicitação</Button>
							</Link>
						)}
					</ButtonsContainer>
				</CardBody>
			</Card>
		</Container>
	);
};

export default ContractSolicitationCompleted;
